<script>
import { translationMixin } from '@/mixins/translationMixin';

export default {
  mixins: [translationMixin],
  components: {},
  methods: {
    handleClose() {
      this.$bvModal.hide('modal-1'); // Close the modal programmatically
    },
    handleResetRide() {
      if (this.onConfirm) {
        this.onConfirm();
      }
      this.handleClose();
    }
  },
  props: {
    btnName: {
      type: String,
      required: true
    },
    modalTitle: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: null
    },
    cancelText: {
      type: String,
      default: null
    },
    showConfirmButtons: {
      type: Boolean,
      default: false
    },
    onConfirm: {
      type: Function,
      default: null
    }
  },
  computed: {
    resolvedConfirmText() {
      return this.confirmText !== null ? this.confirmText : this.t('confirm');
    },
    resolvedCancelText() {
      return this.cancelText !== null ? this.cancelText : this.t('cancel');
    }
  }
};
</script>

<template>
  <div>
    <div>
      <b-button
        v-b-modal.modal-1
        :class="{'warning-button': btnName.includes('⚠️') || btnName.includes(t('popupTemplateResetKeyword'))}"
        class="reset-trip-button"
      >{{ btnName }}</b-button>

      <!-- Modal -->
      <b-modal id="modal-1" class="border-0 shadow rounded-5" hide-footer>
        <!-- Custom Header with Close X -->
        <template #modal-header>
          <button aria-label="Close" class="close" type="button" @click="handleClose">
            <span aria-hidden="true">&times;</span>
          </button>
        </template>

        <!-- Modal Content -->
        <slot></slot>

        <!-- Optional Confirm/Cancel buttons -->
        <div v-if="showConfirmButtons" class="modal-footer-custom">
          <b-button variant="danger" @click="handleResetRide">{{ resolvedConfirmText }}</b-button>
          <b-button variant="secondary" @click="handleClose">{{ resolvedCancelText }}</b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<style>
#modal-1 .modal-header {
  border: none; /* Remove the default border */
}

#modal-1 .modal-content {
  background-color: #f8f9fa; /* Set the background color */
  padding: 12px; /* Adjust padding */
  border-radius: 32px; /* Make content edges rounded */
  border: none;
}

.modal-footer-custom {
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
  border-top: 1px solid #dee2e6;
  margin-top: 15px;
}

.modal-title {
  margin: 0;
  font-weight: bold;
}

.reset-trip-button {
  font-weight: 600;
  white-space: nowrap;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.warning-button {
  background-color: #dc3545 !important;
  border-color: #dc3545 !important;
  color: white !important;
  animation: subtle-pulse 3s infinite;
}

.warning-button:hover {
  background-color: #c82333 !important;
  border-color: #bd2130 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
}

@keyframes subtle-pulse {
  0%, 100% { box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3); }
  50% { box-shadow: 0 2px 8px rgba(220, 53, 69, 0.5); }
}
</style>